module.exports = __webpack_public_path__ + "img/pIndex-ins.1c5903d3.png";